import { useTranslation } from 'src/hooks';
import { useTheme } from 'styled-components';

import { Typography } from '@libs/components';

import { DashboardNavItemType } from 'src/constants';
import {
  IconWrapper,
  NavItem,
  CustomDropDownIcon,
  NewWrapper,
  Disabled,
  ComingSoonWrapper,
} from './styles';

type DashboardNavItemProps = {
  item: DashboardNavItemType;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  shouldRenderArrowIcon?: boolean;
};

const DashboardNavItem: React.FC<DashboardNavItemProps> = ({
  item,
  onClick,
  className,
  shouldRenderArrowIcon,
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (typeof onClick === 'function') {
      onClick(e);
    }
  };

  if (item.shouldHide) {
    return null;
  }

  return (
    <NavItem
      to={item.route}
      onClick={handleClick}
      data-cy={item.title}
      isComingSoon={item?.comingSoon}
      $isNew={item.isNew}
      className={className}
    >
      {({ isActive }) => {
        const color = isActive
          ? colors.interactive.brandColor
          : colors.text.secondary;
        const font = isActive ? 'primaryBold' : 'primaryMedium';
        const icon = isActive ? item.activeIcon : item.icon;

        if (item.isNew) {
          return (
            <>
              <IconWrapper data-cy={`${item.title}-icon`}>{icon}</IconWrapper>
              <Typography
                testId={`${item.title}-text`}
                fontFamily={font}
                type="bodyButton"
                color={color}
              >
                {t(item.title)}
              </Typography>
              <NewWrapper>
                <Typography
                  type="caption"
                  fontFamily="primaryMedium"
                  color={colors.surface.default}
                >
                  {t('common_new')}
                </Typography>
              </NewWrapper>
            </>
          );
        }
        if (item.comingSoon) {
          return (
            <Disabled>
              <IconWrapper data-cy={`${item.title}-icon`}>{icon}</IconWrapper>
              <Typography
                testId={`${item.title}-text`}
                fontFamily={font}
                type="bodyButton"
                color={color}
              >
                {t(item.title)}
              </Typography>
              <ComingSoonWrapper>
                <Typography
                  type="caption"
                  fontFamily="primaryMedium"
                  color={colors.surface.default}
                >
                  {t('common_soon')}
                </Typography>
              </ComingSoonWrapper>
            </Disabled>
          );
        }

        if (shouldRenderArrowIcon) {
          return (
            <>
              <IconWrapper data-cy={`${item.title}-icon`}>{icon}</IconWrapper>

              <Typography
                testId={`${item.title}-text`}
                fontFamily={font}
                type="subHeadline"
                color={color}
              >
                {t(item.title)}
              </Typography>
              <CustomDropDownIcon />
            </>
          );
        }

        return (
          <>
            <IconWrapper data-cy={`${item.title}-icon`}>{icon}</IconWrapper>

            <Typography
              testId={`${item.title}-text`}
              fontFamily={font}
              type="bodyButton"
              color={color}
            >
              {t(item.title)}
            </Typography>
          </>
        );
      }}
    </NavItem>
  );
};

export default DashboardNavItem;
